import RestClient from './rest-client'

export default class ApiKey extends RestClient {
  static get url () {
    return this.apiUrl + '/api_keys'
  }
  
  static get paramKey () {
    return 'api_key'
  }

  static async replaceApiKey (payload) {

    // Then fetch all API keys to delete the old ones
    const allApiKeysResponse = await this._get(this.url)
    // Handle both array response and object with data property
    const allApiKeys = Array.isArray(allApiKeysResponse.data) 
      ? allApiKeysResponse.data 
      : (allApiKeysResponse.data && allApiKeysResponse.data.data) || allApiKeysResponse || []
    
    // Ensure allApiKeys is an array
    const apiKeysArray = Array.isArray(allApiKeys) ? allApiKeys : []
    
    // Delete all API keys except the newly created one
    const deletePromises = apiKeysArray
      .filter(key => key.id !== newApiKey.id)
      .map(key => this._delete(`${this.url}/${key.id}`))
    
    await Promise.all(deletePromises)

    // At last, create the new API key
    const newApiKeyResponse = await this._post(this.url, { [this.paramKey]: payload })
    const newApiKey = newApiKeyResponse
    return { data: newApiKey }
  }
}